export const LOGIN_URL = process.env.VUE_APP_LOGIN_URL;
export const SIGNUP_URL = process.env.VUE_APP_SIGNUP_URL;
export const VUE_APP_REDIRECT_URL = process.env.VUE_APP_URL + '/assets/pages/redirect.html'
export const API_URL = process.env.VUE_APP_API_URL;
